// evaluate for smart or guac session
// set global authData variable based on environment
import { getSmartSessionId } from "@gwn/guac-lib/dist/interfaces/smart";
import { setSmartAuthorizationInterface } from "@gwn/guac-lib/dist/static/authorization";
import { appStore } from "@/nurse-console/store/appStore";
import { getParmInterface, getSmartAuthInterface } from "@/interfaces";

export const authorizationInit = async () => {
  try {
    // console.log("Initializing authorization...");
    appStore().setApplicationState("loading");
    const sessionId = getSmartSessionId();
    let authInterface = null;

    if (sessionId) {
      // console.log("Found SMART session");
      authInterface = await getSmartAuthInterface(sessionId);
      setSmartAuthorizationInterface(authInterface);

      await getParmInterface(true);
      appStore().setAppEnvironment("smart");
    } else {
      // console.log("No SMART session found.");
      appStore().setAppEnvironment("guac");
    }
  } catch (error) {
    // console.error("FAILED: Failed to initialize authorization", error);
    appStore().setApplicationState("error");
    appStore().setMessage(["Internal Server Error", "Please close this page and try again"]);
  }
};
